// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    add_own_options: 'Agrega tus propias opciones',
    allActivities: 'Actividad (tarea, incidencia, solicitud)',
    AllActivities_group_title: 'Campos de actividad (tarea, incidencia, solicitud)',
    batch_mark_as_optional: 'Marcar como opcional',
    batch_mark_as_required: 'Marcar como obligatorio',
    boolean_field_type: 'Casilla de verificación (sí/no)',
    create_cf: 'Crear campo personalizado',
    custom_field_could_not_be_deleted: 'El campo personalizado \"{0}\" no se puede eliminar',
    custom_field_could_not_be_removed: 'El campo personalizado \"{0}\" no se puede quitar',
    custom_field_readonly_warning: 'Solo puedes ver este campo personalizado con tu nivel de acceso. Para hacer cambios, ponte en contacto con el administrador.',
    customer: 'Cliente',
    Customer_group_title: 'Campos de cliente',
    default_field_name: 'Nuevo campo',
    delete_field_title: '¿Eliminar el campo personalizado \"{0}\"?',
    everywhere: 'En todas partes',
    expense: 'Gasto',
    Expense_group_title: 'Campos de gasto',
    field_is_used_in_formula: '1#Este campo personalizado se usa en el campo de fórmula personalizada {0}#Este campo personalizado se usa en los campos de fórmula personalizada {0}',
    field_non_editable_portfolio_restriction: 'Este campo personalizado no pertenece a proyectos en la cartera <b>{0}</b>',
    field_non_editable_without_portfolio_restriction: 'Este campo personalizado no pertenece a proyectos <b>{0} sin cartera</b>',
    field_non_editable_wrong_space: 'Este campo personalizado no pertenece al espacio <b>{0}</b>',
    fields_plural: '1#{0} campo#{0} campos',
    formula_description: 'Para la creación de fórmulas, puedes usar los tipos de campo Número, Dinero y Horas, junto con las operaciones +, -, * y /. Se pueden agregar paréntesis para crear fórmulas compuestas.',
    formula_example: 'Por ejemplo:',
    formula_field_type: 'Fórmula',
    formula_function_description: 'También puedes usar Días Laborales para calcular la diferencia entre dos fechas en días laborables.',
    hyperlink_field_type: 'Hipervínculo',
    issue: 'Incidencia',
    Issue_group_title: 'Campos de incidencia',
    limitReachedMessage: 'Lo sentimos, has alcanzado el número máximo de campos personalizados del tipo elegido que puedes agregar.',
    mark_as_optional_feedback: '1#{0} campo personalizado se ha marcado correctamente como opcional#{0} campos personalizados se han marcado correctamente como opcionales',
    mark_as_optional_feedback_failure: '1#{0} campo personalizado no se pudo marcar como opcional debido a su tipo (desplegable, fórmula o casilla de verificación)#{0} campos personalizados no se pudieron marcar como opcionales debido a su tipo (desplegable, fórmula o casilla de verificación)',
    mark_as_required_feedback: '1#{0} campo personalizado se ha marcado correctamente como obligatorio#{0} campos personalizados se han marcado correctamente como obligatorios',
    mark_as_required_feedback_failure: '1#{0} campo personalizado no se pudo marcar como obligatorio debido a su tipo (desplegable, fórmula o casilla de verificación)#{0} campos personalizados no se pudieron marcar como obligatorios debido a su tipo (desplegable, fórmula o casilla de verificación)',
    msg_deleteUsedValue: 'Este valor se usa en {0} {1}',
    msg_entities_portfolioRemoved: 'Este campo ya no estará disponible para las entidades incluidas en las carteras excluidas.',
    msg_entities_spaceRemoved: 'Este campo ya no estará disponible para las entidades incluidas en los espacios excluidos.',
    msg_lead_to: '¿Deseas guardar los cambios?',
    msg_restrictionsAdded: 'Este campo personalizado tendrá restricción por cartera.',
    msg_restrictionsRemoved: 'Este campo personalizado ya no tendrá restricción por cartera.',
    msg_unportfolioedOff: 'Este campo personalizado no estará disponible para proyectos que no estén incluidos en carteras.',
    msg_valueRemoved: 'Cualquier elemento excluido de la lista se eliminará permanentemente.',
    no_portfolio: 'Sin cartera',
    nowhere: 'En ningún lugar',
    numeric_field_type: 'Número',
    other_portfolios: 'Otras carteras',
    portfolio: 'Cartera',
    Portfolio_group_title: 'Campos de cartera',
    project: 'Proyecto',
    Project_group_title: 'Campos de proyecto',
    readonly_warning_no_access_to_portfolios: 'Solo puedes ver este campo personalizado porque está asociado a carteras a las que no tienes acceso.',
    remove_field_description: 'El campo personalizado seguirá estando disponible en la configuración de la empresa.',
    remove_field_title: '¿Deseas quitar el campo personalizado \"{0}\" de \"{1}\"?',
    request: 'Solicitud',
    Request_group_title: 'Campos de solicitud',
    required_fileds_not_filled: '1#Falta completar {0} campo obligatorio#Faltan completar {0} campos obligatorios',
    select_from: 'Selecciona campo personalizado',
    spaces_field_label: 'Espacios',
    spaces_field_section_title: 'Disponible en espacios',
    task: 'Tarea',
    Task_group_title: 'Campos de tarea',
    text_add: 'Agregar',
    text_add_new_item: 'Agrega un nuevo elemento o usa Ctrl+V para pegar una lista de elementos',
    text_add_portfolio: 'Agregar cartera',
    text_addDescription: 'Agregar descripción',
    text_all_objects: 'Todos los objetos',
    text_available_in: 'Carteras para el campo',
    text_create_new_field: 'Agregar campo personalizado',
    text_currentIdentity: 'Empezar desde',
    text_custom_field_for: 'Campo para',
    text_delete: 'Eliminar campo',
    text_delete_permanently: 'Eliminar permanentemente',
    text_deleteValue: 'Eliminar valor',
    text_edit: 'Editar campo',
    text_empty_page_part1: '¿Necesitas más flexibilidad para rastrear e informar sobre tus datos?',
    text_empty_page_part2: 'Agrega tus propios campos para proyectos, tareas, usuarios y más...',
    text_error_title: 'No se pudo completar la operación.',
    text_field_type: 'Texto',
    text_fieldName: 'Nombre del campo',
    text_fieldType: 'Tipo de campo',
    text_filter: 'Campos personalizados para',
    text_include_in_unportfolioed_projects: 'También mostrarlo para proyectos que no están incluidos en portafolios',
    text_isIdentity: 'Auto-incremento',
    text_isNumeric: 'No mostrar decimales',
    text_isRequired: 'Obligatorio',
    text_place_plural: '1#lugar#lugares',
    text_remainingValuesTemplate: 'mostrar \"{0}\" elementos ocultos en la parte superior de la lista',
    text_remove: 'Eliminar',
    text_restricted_by_portfolio: 'Limitar por portafolio',
    text_selectionMode: 'Modo de selección',
    text_set_restrictions: 'Mostrar este campo solo para proyectos incluidos en portafolios seleccionados',
    textarearich_field_type: 'Texto de párrafo (formato enriquecido)',
    timeEntry: 'Registro de tiempo',
    TimeEntry_group_title: 'Campos de registro de tiempo',
    tooltip_disable_batch: 'Solo puedes ver el campo personalizado con tu nivel de acceso. Para hacer cambios, ponte en contacto con el administrador.',
    tooltip_everywhere: '<b>En todas partes</b> - el campo personalizado no tiene restricciones de visibilidad.',
    tooltip_nowhere: '<b>En ninguna parte</b> - el campo personalizado no está incluido en ningún lado.',
    tooltip_other_portfolios: '<b>Otros portafolios</b> - se refiere a portafolios a los que no tienes los permisos necesarios para acceder.',
    tooltip_portfolio_and_without_part1: '<b>Nombre del portafolio, </b>',
    tooltip_portfolio_and_without_part2: '<b>Sin portafolio</b> - el campo personalizado está incluido en entidades de portafolios seleccionados y en entidades sin portafolio.',
    tooltip_portfolio_name: '<b>Nombre del portafolio</b> - el campo personalizado está incluido en los portafolios seleccionados.',
    tooltip_without_portfolio: '<b>Sin portafolio</b> - el campo personalizado está incluido en entidades sin portafolio.',
    unknown_portfolio_description: 'Se refiere a portafolios a los que no tienes los permisos necesarios para acceder.',
    upgradeToEnterpriseMessage: 'Has alcanzado el límite de la Edición de Equipo. Por favor <a href=\"{licenseUrl}\" target=\"_blank\">actualiza</a> a {brandName} Edición Enterprise.',
    use_cfs_options: 'Usar campo personalizado como fuente de opciones',
    use_own_options: 'Usar tus propias opciones',
    user: 'Usuario',
    user_checkbox_list_text: 'Selección múltiple de usuarios',
    user_dropdown_text: 'Lista desplegable de usuarios',
    User_group_title: 'Campos de usuario',
    validation_error_InvalidBracketsNumber: 'Uso incorrecto de paréntesis',
    validation_error_InvalidField: 'Entrada de campo inválida. El campo \"{0}\" no existe',
    validation_error_InvalidOperation: 'Uso inválido de operaciones matemáticas. Solo se permiten los operadores ‘+’, ‘-’, ‘*’ y ‘/’',
    validation_error_InvalidSymbol: 'Uso inválido de símbolos',
    validation_error_MismatchedArgumentType: 'Solo se pueden usar fechas como argumentos para la función $WORKING_DAYS.',
    validation_error_MismatchedInput: 'Fórmula incompleta. Asegúrate de que todos los símbolos y operadores estén incluidos para crear una fórmula válida',
    validation_error_MismatchedOperandType: 'Los campos de fecha no pueden usarse en operaciones aritméticas. Usa la función $WORKING_DAYS(@Date1, @Date2) para trabajar con ellos.',
    validation_error_MismatchedReturnType: 'Los campos de fecha no pueden usarse en operaciones aritméticas. Usa la función $WORKING_DAYS(@Date1, @Date2) para trabajar con ellos.',
    validation_error_Unknown: 'Formato de fórmula inválido. La fórmula que ingresaste tiene un formato inválido y no se pudo analizar correctamente',
    visibility_title: 'Visibilidad',
    warning_linked_global_field_activities: 'Los cambios en este campo personalizado afectarán a actividades en varios espacios.',
    warning_linked_global_field_expenses: 'Los cambios en este campo personalizado afectarán a gastos en varios espacios.',
    warning_linked_global_field_projects: 'Los cambios en este campo personalizado afectarán a proyectos en varios espacios.',
    warning_linked_global_field_time: 'Los cambios en este campo personalizado afectarán a registros de tiempo en varios espacios.',
    warning_wont_visible_without_space: 'El campo personalizado no será visible para los usuarios hasta que se agregue al espacio.',
};
